import React, { Component } from 'react';
import icPlay from '../../../assets/img/ic-play.svg'
import { Link } from "react-router-dom";
import Util from '../../../utils/utils';
import Progress from "../util/progress";

class Discussions extends Component
{
	constructor ( props )
	{
		super( props );
		this.props = props;
	}

	lastItemHandle = () =>
	{
		if ( this.props.playAtLastItem )
		{
			Util.setSession( "last_item", true )
		}
		else
		{
			Util.setSession( "last_item", false )
		}
	};

	renderItems = () =>
	{
		return this.props.courses.map( ( item, key ) => (
			<div key={key} className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6 book-cards">
				<Link
					to={{
						pathname : this.props.url + item.meta_id
					}}
					onClick={this.lastItemHandle}
				>
					<div className="continue-discussion-card row">
						<div className="col-12 m-0 continue-discussion-card-decription">
							<p className="continue-discussion-title">
								{item.item_title}
							</p>
							<div className="d-flex align-items-center justify-content-between continue-discussion-parent-div">
								<p className="continue-discussion-category">
									{item.course_title !== undefined && item.course_title}
									{item.items_count !== undefined && item.items_count + " جلسه "}
								</p>
								<p className="m-0 align-self-center continue-discussion-card-button">
									<img className="ic-play" src={icPlay} alt=""/>
								</p>
							</div>
						</div>
						<div className="progress-bar-back col-12 p-0">
							<Progress width={ item.width} type={1}/>
						</div>
					</div>
				</Link>
			</div>
		) );
	};

	render ()
	{

		if ( this.props.courses && this.props.courses.length > 0 )
		{
			return (
				<section className="continue-discussions">
					<h2 className="continue-discussions-title">
						{this.props.title}
					</h2>
					<div className="continue-discussions-div card-group card-group-scroll-learn no-scrollbar">
						{this.renderItems()}
					</div>
				</section>
			);
		}
		else
		{
			if ( this.props.showTitle )
			{
				return (
					<section className="continue-discussions">
						<h2 className="continue-discussions-title">
							{this.props.title}
						</h2>
					</section> );
			}
		}

		return ( <></> );
	}
}

export default Discussions;
